<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'
import { ToastType, type ToastOptions } from 'vue3-toastify'

export default defineComponent({
  props: {
    closeToast: Function as PropType<(e?: MouseEvent) => void>,
    toastProps: Object as PropType<ToastOptions>
  },
  setup(props) {
    const type: ToastType = props.toastProps?.type || 'info'
    const message: string = props.toastProps?.data?.['message'] || 'Message'

    const computedClass = computed(() => {
      let sClass = ''

      switch (type) {
        case 'success':
          sClass += 'border-adk-lightGreen'
          break
        case 'warning':
          sClass += 'border-adk-main'
          break
        case 'error':
          sClass += 'border-adk-lightRed'
          break
        default:
          sClass += 'border-adk-lightBlue'
          break
      }

      return sClass
    })

    const iconSrc = computed(() => `images/icons/toast/${type}.svg`)

    return {
      type,
      message,
      iconSrc,
      computedClass
    }
  }
})
</script>

<template>
  <div
    data-test="mcd-toast"
    class="w-full flex min-h-vh-64 cursor-pointer flex-col justify-center rounded-md border-l-vw-8 bg-adk-black p-vh-16 shadow-lg"
    :class="computedClass"
  >
    <div class="flex flex-row items-center gap-vw-8">
      <img :src="iconSrc" class="w-auto h-vh-16 self-center" alt="toast-icon" />
      <p class="text-white text-small">{{ message }}</p>
    </div>
  </div>
</template>
